// non vue related front end scripts

require('./accordions')
require('./iframes')
require('./cookie-bar')
require('./swiper-sliders')
require('./logo')



// WEBPACK FOOTER //
// ./resources/assets/js/scripts.js